<div class="video-link-container">
    <a class="btn" (click)="onVideoIconClick()">
        <i class="fas fa-camera-retro fa-lg"></i><span class="icon-title" [innerText]="title"></span>
    </a>
</div>
